import React, { useContext, useState, useEffect } from "react";
import Col from "../../../UIcomponent/Column";
import LocalContext from "../../../Context/LocalContetxt";
import "./ProfileWeekly.scss";
import { Loader } from "../../../UIcomponent/Loader";
import ProfileReq from "../../../Utility/Requester/ProfileReq";
import LocalConfig from "../../../Utility/Method/LocalConfig";
import Schedule from "../../CalendarSchedule/Schedule";
import { Notify } from "../../../UIcomponent/NotificationManager";
import Metas from "../../Metas";

const ProfileWeekly = (props) => {
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(false);

  const getAvailabilty = (showNotif) => {
    let TimeSlot = [...Data];
    ProfileReq.Weekly(config.userID)
      .then((res) => {
        console.log(res.data);
        TimeSlot =
          res.data !== null
            ? res.data.map((each) => {
                if (config.timeZone == "Asia/Tehran") {
                  return {
                    ...each,
                    Start:
                      each.Start + 24 > 168
                        ? each.Start + 24 - 168
                        : each.Start + 24,
                    End:
                      each.End + 24 > 168 ? each.End + 24 - 168 : each.End + 24,
                  };
                } else {
                  return each;
                }
              })
            : [
                // {
                //     Start: 0,
                //     End: 0
                // }
              ];
        setData(TimeSlot);
        setLoading(false);
        showNotif === true &&
          Notify("success", "تغییرات با موفقیت انجام شد", 4000);
      })
      .catch((err) => {
        setLoading(false);
        Notify("error", err.response.data.message, 4000);
      });
  };

  useEffect(() => {
    getAvailabilty();
  }, []);
  const onSubmit = (Slots) => {
    setIsSubmiting(true);
    let newSlot = Slots.map((each) => {
      return {
        Start: each.Start !== 168 ? each.Start : 0,
        End: each.End !== 0 ? each.End : 168,
      };
    });
    let data = {
      Slots: newSlot,
    };
    ProfileReq.WeeklyUpdate(data)
      .then((res) => {
        setIsSubmiting(false);
        getAvailabilty(true);
      })
      .catch((err) => {
        setIsSubmiting(false);
      });
  };
  return (
    <>
      <Metas title="زمانبندی | لینگوتاک" description="زمانبندی | لینگوتاک" />

      {/* <Col className="c__NotAvailableOnMobile">
        این صفحه در دسکتاپ قابل استفاده می باشد.
      </Col> */}
      <Col
        className="l__ProfileWeekly"
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        lang={lang}
      >
        <Col
          className="c__ProfileWeekly"
          xl={23}
          lg={23}
          md={23}
          sm={24}
          xs={24}
        >
          {/* {Data.length > 0 && */}
          <Schedule
            duration={0.5}
            lang={lang}
            row={8}
            size={30}
            Data={Data}
            loading={loading}
            Loader={Loader}
            onSubmit={onSubmit}
            isSubmiting={isSubmiting}
            timezone={config.timeZone}
          />
          {/* } */}
        </Col>
      </Col>
    </>
  );
};

export default ProfileWeekly;
